import { gql } from '@apollo/client'

export const Query = gql`
  query EditCompanyUser($companyId: ID!, $filters: CompanyUserFilters) {
    companyUsers(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        initiatedBy { id name }
        user { id name email }
        acceptedAt
        role
      }
    }
  }
`
